import { GraphQLEnumType } from 'graphql'

export type ServerOrderField = 'NAME' | 'ENVIRONMENT' | 'LAST_SEEN' | 'VERSION'

export const serverOrderFieldType = new GraphQLEnumType({
  name: 'ServerOrderField',
  description: 'Directions to sort a list of servers',
  values: {
    NAME: {
      description: 'Order servers by server name'
    },
    ENVIRONMENT: {
      description: 'Order servers by deployment environment'
    },
    LAST_SEEN: {
      description: 'Order servers by last observed activity'
    },
    VERSION: {
      description: 'Order servers by agent version'
    }
  }
})
